export enum ReenrollPages {
    PrescriberInformation = 1,
    PatientInformation = 2,
    PayerInformation = 3,
}
